import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("vp_token") || sessionStorage.getItem("vp_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("vp_token");
      sessionStorage.removeItem("vp_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const setSession = (token, u, remember = true) => {
    localStorage.removeItem("vp_token");
    sessionStorage.removeItem("vp_token");
    (remember ? localStorage : sessionStorage).setItem("vp_token", token);
    setUser(u);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("vp_token");
    sessionStorage.removeItem("vp_token");
    Object.keys(localStorage)
      .filter((k) => k.startsWith("vp_assistant_"))
      .forEach((k) => localStorage.removeItem(k));
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, setSession, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
